export enum InvestmentRealEstateAddPopupCloseEventType {
	AddNew,
	AddExisting,
	Cancel
}

export interface InvestmentRealEstateAddPopupCloseEvent {
	type: InvestmentRealEstateAddPopupCloseEventType,
	property?: any,
}